import { useCountriesList } from "@/hooks/queries/country/useCountryQueries";
import { CountryData } from "@/services/countries/CountriesService";
import { createContext, useContext, useMemo } from "react";

const CountriesContext = createContext(undefined);

type CountriesContextType = {
  countries: CountryData[];
  countryNames: string[];
};

export const useCountries = (): CountriesContextType => useContext(CountriesContext);

export const CountriesProvider = ({ children }) => {
  const { data: countries = [] } = useCountriesList();
  const countryNames = useMemo(() => countries?.map((c) => c.name) || [], [countries]);

  return <CountriesContext.Provider value={{ countries, countryNames }}>{children}</CountriesContext.Provider>;
};
